export var SettingCategory;
(function (SettingCategory) {
    SettingCategory["GENERAL"] = "GENERAL";
    SettingCategory["EMAIL"] = "EMAIL";
    SettingCategory["INVOICE"] = "INVOICE";
    SettingCategory["TAX"] = "TAX";
})(SettingCategory || (SettingCategory = {}));
